<template>
    <div id="verdict-and-killchain-container">
        <img id="verdict-and-killchain-go-back-button" src="../assets/left-arrow.png" alt="go back"
             @click="backButtonHandler" v-if="!isLoading">
        <!--<font-awesome-icon icon="coffee" />-->
        <iframe id="verdict-and-killchain-iframe" :src="URL" frameBorder="0"
                allowfullscreen v-if="!isLoading"></iframe>
        <loading-modal v-if="isLoading"></loading-modal>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';
    import Constants from '@/utils/constants'
    import LoadingModal from '@/components/modals/LoadingModal.vue'

    export default {
        name: "VerdictAndKillchain",
        components: {
            LoadingModal: LoadingModal
        },
        data() {
            return {
                // URL: null,
                // selection: null,
                isLoading: true,
                count: 0,
                verdictLoginResponse: {}
            }
        },
        computed: {
            URL() {
                return this.getIframeUrl;
            },
            selection() {
                return this.getIframeSelection;
            },
            ...mapGetters([
                "getIframeUrl",
                "getIframeSelection",
                "getIsComingFromSearchBar"
            ])
        },
        methods: {
            backButtonHandler() {
                this.$emit("backButtonHandlerMainPage");
            },
            showErrorTos(errorMessage) {
                $("#app").css("opacity", "0.4");
                let div = document.createElement("div");
                div.className += "overlay";
                document.body.appendChild(div);
                this.$toasted.show(errorMessage, {
                    position: "bottom-center",
                    duration: 2500,
                    type: 'error'
                });
                setTimeout(function () {
                    $("#app").css("opacity", "1");
                    $(".overlay").remove();
                }, 2500)
            },
            verdictLoginHandler(response) {
                if (response.data.return_code === Constants.ReturnCodes.Success) {
                    this.verdictLoginResponse = response.data.data;
                    this.setIframeUrl(this.URL + "&access_token=" + this.verdictLoginResponse.access_token)
                } else if (response.data.return_code === Constants.ReturnCodes.Error
                    || response.data.return_code === Constants.ReturnCodes.ServerError
                    || response.data.return_code === Constants.ReturnCodes.ArgumentError) {
                    this.showErrorTos(response.data.data);
                }
            },
            authVerdictLogin() {
                let path = Constants.INTELLIGENCE_BACKEND_URL + '/verdict/login';
                let body = {};
                this.$http.post(path, body).then(response => {
                    this.verdictLoginHandler(response);
                    this.isLoading = false;
                }, response => {
                    this.showErrorTos("Request Error. Please contact with the support.");
                    this.isLoading = false;
                });
            },
            adjustParameters() {
                if (this.selection === Constants.IframeSelections.Verdict) {
                    this.authVerdictLogin();
                } else if (this.selection === Constants.IframeSelections.Killchain) {
                    this.isLoading = false;
                }
            },
            ...mapActions([
                "setIframeUrl"
            ])
        },
        beforeMount() {
            this.adjustParameters();
            if (!this.getIsComingFromSearchBar)
                this.$emit("clearVerdictSearchBar");
        },
        updated() {
            if (!this.getIsComingFromSearchBar)
                this.$emit("clearVerdictSearchBar");
        }
    }
</script>

<style scoped>
    #verdict-and-killchain-container {
        display: flex;
        margin: 16px;
        height: 93%;
        overflow: hidden;
    }

    #verdict-and-killchain-iframe {
        width: 100%;
        height: 100%
    }

    #verdict-and-killchain-go-back-button {
        margin-top: 8px;
        margin-right: 8px;
        width: 32px;
        height: 32px;
        cursor: pointer;
    }

</style>



// WEBPACK FOOTER //
// src/pages/VerdictAndKillchain.vue